import { Icon, IconProps } from '@chakra-ui/react';
import * as React from 'react';

export const SSOIcon: React.FC<IconProps> = (props) => (
  <Icon
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color="blue.500"
    {...props}
  >
    {/* Shield */}
    <path
      d="M12 2L3 7V12C3 16.4183 6.58172 20 11 20H13C17.4183 20 21 16.4183 21 12V7L12 2Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="currentColor"
      fillOpacity="0.1"
    />

    {/* Padlock Body */}
    <rect
      x="9"
      y="11"
      width="6"
      height="5"
      rx="1"
      stroke="currentColor"
      strokeWidth="2"
      fill="currentColor"
      fillOpacity="0.2"
    />

    {/* Padlock Shackle */}
    <path
      d="M9 11V9C9 7.34315 10.3431 6 12 6C13.6569 6 15 7.34315 15 9V11"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />

    {/* Keyhole */}
    <circle cx="12" cy="13.5" r="0.5" fill="currentColor" />
    <rect x="11.5" y="13.5" width="1" height="1.5" fill="currentColor" />
  </Icon>
);
